// Template Generated by DataExtraction.py at 1716507313

import TransferEnglish2 from "../../Forms/Transfer/Transfer_English2.png";
import TransferEnglish2Labels from "../../Labels/Transfer/Transfer_English2.json";
import TransferFrench2 from "../../Forms/Transfer/Transfer_French2.png";
import TransferFrench2Labels from "../../Labels/Transfer/Transfer_French2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench2Labels : TransferEnglish2Labels;
    const formImage = isFrench ? TransferFrench2 : TransferEnglish2;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;

    const subscriber1SignDate = moment().format("YYYY-MM-DD");
    const subscriber2SignDate = moment().format("YYYY-MM-DD");

    // Drawing the form
    // TODO implement fields
    drawText(subscriber1SignDate, "subscriber1SignDate");
    if (common.subscriber2Include) {
        drawText(subscriber2SignDate, "subscriber2SignDate");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench2Labels : TransferEnglish2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber2Include = state.common.subscriber2Include;

    if (subscriber2Include) {
        // signatureView2
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("signatureView2", labels))],
        });
    }


    // subscriber1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("subscriber1Signature", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
